
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonClosed as ObiThreewayAcuatorPistonClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-closed.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonClosed = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-closed',
   elementClass: ObiThreewayAcuatorPistonClosedElement,
   events: {
     
   }
  });
 
 